import { ContentActionRef, ContentActionType } from '@alfresco/adf-extensions';

export class Constants {
    
    public static GROUP_MEMBERSHIP_UPDATE_TIMEOUT_VALUE = 16000;
    public static AVATAR_UPDATE_TIMEOUT_VALUE = 1000;
    public static FILESYSTEM_UPDATE_TIMEOUT_VALUE = 500;
    public static CONTINUED_TYPING_THRESHOLD_VALUE = 750;

    public static CUSTOM_PAGE_ACTIONS: ContentActionRef[] = [
        {
            actions: { click: 'SEARCH' },
            data: { buttonType: 'icon-button' },
            disabled: false,
            icon: "search",
            id: "app.toolbar.search",
            order: 90,
            rules: { visible: 'app.isSearchSupported' },
            title: "SEARCH.BUTTON.TOOLTIP",
            type: ContentActionType.button,
        }
    ];

    // if changing, note duplicates in aca-shared/rules/src/constants.ts
    public static GROUP_ARCHIVE_USERS_ID = "ARCHIVE_USERS";
    public static GROUP_ARCHIVE_ADMINS_ID = "ARCHIVE_ADMINS";
    public static GROUP_ARCHIVE_CREATORS_ID = "ARCHIVE_CREATORS";
    public static GROUP_WORKFLOW_REPORTING_ID = "NEOWORKFLOW_WORKFLOW_REPORTING";
    public static GROUP_ACTIVITY_FEED_ID = "NEOWORKFLOW_ACTIVITY_FEED";
    public static GROUP_LLEIDA_ID = "LLEIDA";
    public static GROUP_COMPANY_SIGNATURE_ID = "COMPANY_SIGNATURE";

    public static START_WORKFLOW_HIDDEN_GROUPS = [
        Constants.GROUP_ARCHIVE_USERS_ID,
        Constants.GROUP_ARCHIVE_ADMINS_ID,
        Constants.GROUP_ARCHIVE_CREATORS_ID,
        Constants.GROUP_WORKFLOW_REPORTING_ID,
        Constants.GROUP_ACTIVITY_FEED_ID,
        Constants.GROUP_LLEIDA_ID,
        Constants.GROUP_COMPANY_SIGNATURE_ID,
        'ALFRESCO_ADMINISTRATORS',
        'ALFRESCO_MODEL_ADMINISTRATORS',
        'ALFRESCO_SEARCH_ADMINISTRATORS',
        'ALFRESCO_SYSTEM_ADMINISTRATORS',
        'EMAIL_CONTRIBUTORS',
        'SITE_ADMINISTRATORS',
        'SUBJECT_EXPIRING_NOTIFIED',
    ];
};